<template>
    <div style="background: #ededed;">
        <section class="container list-wrap">
            <section class="info-title">
                <div class="new-icon"></div>
                <div style="font-size: 2.0625rem;">{{title}}</div>
            </section>
            <section class="info-details">
                <router-link class="content-item" :to="{ name: 'list-details', query: { id: item.id }}"
                    v-for="(item,index) in posts" :key="index">
                    <section class="item-left">
                        <img class="icon" src="../../assets/notice-icon.png">
                        <div class="post_title hd">{{item.title.rendered}}</div>
                    </section>
                    <div>{{item.date.split('T')[0]}}</div>
                </router-link>
            </section>
            <section class="pag" v-if="posts.length">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="page" :page-sizes="[10,20,50,100]" :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </section>
        </section>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'list',
        data() {
            return {
                title: '',
                categories: '',
                posts: [],
                total: 0,
                page: 1,
                size: 10
            }
        },
        mounted() {
            switch (this.$route.query.tag) {
                case 'news':
                    this.title = '最新动态';
                    this.categories = 2;
                    break;
                case 'each':
                    this.title = '各区动态';
                    this.categories = 3;
                    break;
                case 'work_content':
                    this.title = '工作内容';
                    this.categories = 5;
                    break;
                case 'policy_advocacy':
                    this.title = '政策宣传';
                    this.categories = 6;
                    break;
                case 'information-query':
                    this.title = '信息查询';
                    this.categories = 9;
                    break;
                case 'honest-service':
                    this.title = '服务诚信承诺';
                    this.categories = 10;
                    break;
                case 'search-result':
                    this.title = '搜索结果';
                    break;
                default:
                    break;
            }
            if (this.$route.query.tag === 'search-result') {
                axios.get('http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?s=' + this.$route.query.keyword)
                    .then(response => {
                        this.posts = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            } else {
                this.getListData();
            }
        },
        methods: {
            handleSizeChange(el) {
                this.size = el;
                this.getListData();
            },
            handleCurrentChange(el) {
                this.page = el;
                this.getListData();
            },
            getListData() {
                axios.get('http://www.yijian.sh.cn/dist/wordpress/index.php/wp-json/wp/v2/posts?page=' + this.page + '&per_page=' + this.size + '&categories=' + this
                        .categories)
                    .then(response => {
                        console.log(response.headers['x-wp-total']);
                        this.total = parseInt(response.headers['x-wp-total']);
                        this.posts = response.data;
                    })
                    .catch(e => {
                        console.log(e);
                    })
            }
        }
    }
</script>

<style scoped>
    .post_title {
        width: 62.5rem;
    }

    .list-wrap {
        min-height: calc(100vh - 575.5px);
        height: auto;
        background: #fff;
        position: relative;
    }
    
    .pag {
        position: absolute;
        bottom: 1.428571rem;
        right: 0.714285rem;
    }
    
    .info-details {
        padding-bottom: 6rem;
    }
</style>
